<navigation-logo class="logo" [mode]="'desktop'" [isOpen]="isOpen"></navigation-logo>

<tui-scrollbar class="navigation" [class.navigation_min]="!isOpen">
  <app-navigation-list
    [mode]="'desktop'"
    [isOpen]="isOpen"
    [navTree]="navTree"
    [additionalNavItems]="pagesNavItems$ | async"
  ></app-navigation-list>
</tui-scrollbar>

<navigation-message
  class="message"
  [class.message_min]="!isOpen"
  [mode]="'desktop'"
  [isOpen]="isOpen"
></navigation-message>

<association-menu *ngIf="associationMenuVisible" [isOpen]="isOpen" [mode]="'desktop'"></association-menu>

<div class="navigation-footer">
  <a class="version-link" routerLink="/settings/changelog">{{ appVersion }}</a>
</div>
